import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//Data
import popupDataBtn from "../../json/LoginScreen/button.json";

// Components
import LoadingScreenComponent from "../../components/LoadingScreenComponent/LoadingScreenComponent";
import VersionTxtComponent from "../../components/VersionTxtComponent/VersionTxtComponent";
import NavbarComponent from "../../components/NavbarComponent/NavbarComponent";
import NavbarMobile from "../../components/NavbarMobile/NavbarMobile";
import NavbarMobileBottom from "../../components/NavbarMobileBotton/NavbarMobileBottom";
import SideMenusComponent from "../../components/SideMenusComponent/SideMenusComponent";
import AttachAppendixBody from "../../components/body/AttachAppendixBody/AttachAppendixBody";
import PopUpComponent from "../../components/PopUpComponent/PopUpComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";
import { PopupContext } from "../../context/PopupContext";

const AttachAppendixScreen = ({ userData, userMenuData }) => {
  const { loading, hasComplementTxt } = useContext(LoadingContext);

  const { showPopup, popupData } = useContext(PopupContext);

  const history = useNavigate();

  const currentStep = localStorage.getItem("latestStep");

  const processType = localStorage.getItem("processType");

  useEffect(() => {
    if (processType === "new-credit") {
      switch (currentStep) {
        case "attach-document":
          history("/admin/crear-credito/adjuntar-poliza");
          break;
        case "attach-policy":
          history("/admin/crear-credito/adjuntar-anexo");
          break;
        case "attach-appendix":
          history("/admin/crear-credito/formulario");
          break;
        case "complement-data":
          history("/admin/crear-credito/formulario-confirmar");
          break;
        default:
          break;
      }
    } else if (processType === "renovation") {
      switch (currentStep) {
        case "validate-document":
          history("/admin/crear-credito/adjuntar-poliza");
          break;
        case "attach-policy":
          history("/admin/crear-credito/adjuntar-anexo");
          break;
        case "attach-appendix":
          history("/admin/crear-credito/verificar-datos");
          break;
        case "verify-data":
          history("/admin/crear-credito/formulario-renovacion");
          break;
        case "complement-data-renovation":
          history("/admin/crear-credito/formulario-renovacion-confirmar");
          break;
        default:
          break;
      }
    }
  }, [currentStep, history, processType]);

  return (
    <>
      {showPopup && (
        <PopUpComponent content={popupData} btnData={popupDataBtn.data[0]} />
      )}
      {loading && (
        <LoadingScreenComponent hasComplementTxt={hasComplementTxt} />
      )}
      <div className="body-container">
        <VersionTxtComponent />
        <div className="body-subcontainer">
          <NavbarComponent userData={userData} />
          <NavbarMobile userData={userData} menuData={userMenuData} />
          <AttachAppendixBody userData={userData} />
          <NavbarMobileBottom />
        </div>
        <SideMenusComponent menuData={userMenuData} />
      </div>
    </>
  );
};

export default AttachAppendixScreen;
